module.exports = __webpack_public_path__ + "8e687a044d7ae3b2d4499cea15935f22.svg";